import type { ReactNode } from 'react';
import { Card, Text, Group, Box } from '@mantine/core';
import { fmt } from '../lib/format';

type Variant = 'default' | 'accent' | 'filled';

export function StatCard({
  label,
  value,
  sub,
  variant = 'default',
  right,
}: {
  label: string;
  value: number | string;
  sub?: ReactNode;
  variant?: Variant;
  right?: ReactNode;
}) {
  const filled = variant === 'filled';
  const extra: Record<string, unknown> = {};
  if (filled) {
    extra['bg'] = 'navy.9';
    extra['withBorder'] = false;
  }
  return (
    <Card padding="lg" radius="xl" h="100%" {...extra}>
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Text
          size="xs"
          fw={600}
          tt="uppercase"
          c={filled ? 'rgba(255,255,255,0.7)' : 'dimmed'}
          style={{ letterSpacing: '0.04em' }}
        >
          {label}
        </Text>
        {right}
      </Group>
      <Text
        className="tnum"
        ff='"Source Serif 4", serif'
        fw={600}
        fz={34}
        mt={6}
        lh={1.1}
        c={filled ? 'white' : 'navy.9'}
      >
        {typeof value === 'number' ? fmt(value) : value}
      </Text>
      {sub && (
        <Box mt={6}>
          {typeof sub === 'string' ? (
            <Text size="xs" c={filled ? 'rgba(255,255,255,0.65)' : 'dimmed'}>
              {sub}
            </Text>
          ) : (
            sub
          )}
        </Box>
      )}
    </Card>
  );
}
